import React from 'react';
import './logolist.scss';

const partnerLogos = [
  { src: '/images/partner_1.svg', alt: 'Partner 1' },
  { src: '/images/partner_2.svg', alt: 'Partner 2' },
  // { src: '/images/partner_3.svg', alt: 'Partner 3' },
  { src: '/images/partner_4.svg', alt: 'Partner 4' },
  { src: '/images/partner_5.svg', alt: 'Partner 5' },
  { src: '/images/partner_6.svg', alt: 'Partner 6' },
  { src: '/images/partner_7.svg', alt: 'Partner 7' },
  // { src: '/images/partner_8.svg', alt: 'Partner 8' },
  { src: '/images/partner_9.svg', alt: 'Partner 9' },
  // { src: '/images/partner_10.svg', alt: 'Partner 10' },
  { src: '/images/partner_11.svg', alt: 'Partner 11' },
  // { src: '/images/partner_12.svg', alt: 'Partner 12' },
  { src: '/images/partner_13.svg', alt: 'Partner 13' },
  { src: '/images/partner_14.svg', alt: 'Partner 14' },
  { src: '/images/partner_15.svg', alt: 'Partner 15' },
  { src: '/images/partner_16.svg', alt: 'Partner 16' },
  { src: '/images/partner_17.svg', alt: 'Partner 17' },
  { src: '/images/partner_18.svg', alt: 'Partner 18' },
  { src: '/images/partner_19.svg', alt: 'Partner 19' },
  { src: '/images/partner_20.svg', alt: 'Partner 20' },
  { src: '/images/partner_21.svg', alt: 'Partner 21' },
  { src: '/images/partner_22.svg', alt: 'Partner 22' },
  { src: '/images/partner_23.svg', alt: 'Partner 23' },
  { src: '/images/partner_24.svg', alt: 'Partner 24' },
  { src: '/images/partner_25.svg', alt: 'Partner 25' },
  { src: '/images/partner_26.svg', alt: 'Partner 26' },
  { src: '/images/partner_27.svg', alt: 'Partner 27' },
  { src: '/images/partner_28.svg', alt: 'Partner 28' },
  { src: '/images/partner_29.svg', alt: 'Partner 29' },
  // { src: '/images/partner_30.svg', alt: 'Partner 30' },
  { src: '/images/partner_31.svg', alt: 'Partner 31' },
  { src: '/images/partner_32.svg', alt: 'Partner 32' },
  // { src: '/images/partner_33.svg', alt: 'Partner 33' },
];

export default function LogoList() {
  return (
    <div className="marquee-container">
      <div className="marquee-content">
        {/* First set of logos */}
        {partnerLogos.map((logo, index) => (
          <div className="logo-item" key={`first-${index}`}>
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
        
        {/* Duplicate set for seamless looping */}
        {partnerLogos.map((logo, index) => (
          <div className="logo-item" key={`second-${index}`}>
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </div>
    </div>
  );
}